import { Component, Input, OnInit } from '@angular/core'
import { BreadcrumbLink } from 'src/app/shared/interfaces/breadcrumb-link.interface'
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-head-generative-ai',
  templateUrl: './head-generative-ai.component.html',
  styleUrls: ['./head-generative-ai.component.scss']
})
export class HeadGenerativeAiComponent implements OnInit {
  @Input() selectedNavItem: string
  breadcrumbLinks: BreadcrumbLink[]
  purposeId = environment.purposeId

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    const capitalizedNavItem =
      this.selectedNavItem.charAt(0).toUpperCase() +
      this.selectedNavItem.slice(1)

    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      'generativeAI',
      [
        {
          label: capitalizedNavItem,
          path: `genai/${this.selectedNavItem}`
        }
      ]
    )
  }
}
